import React, { forwardRef, useCallback, useRef, useEffect } from 'react'

type FlexDivProps = React.HTMLAttributes<HTMLDivElement> & {
  direction?: 'row' | 'column'
  gap?: number | string
  align?: React.CSSProperties['alignItems']
  justify?: React.CSSProperties['justifyContent']
  flex?: number
  onLoad?: () => void
}

export const FlexDiv = forwardRef<HTMLDivElement, FlexDivProps>(
  ({ direction = 'row', flex, gap, align, justify, style, children, onLoad, ...rest }, forwardedRef) => {
    const internalRef = useRef<HTMLDivElement | null>(null)

    const setRefs = useCallback(
      (node: HTMLDivElement | null) => {
        internalRef.current = node

        if (typeof forwardedRef === 'function') {
          forwardedRef(node)
        } else if (forwardedRef) {
          forwardedRef.current = node
        }
      },
      [forwardedRef],
    )

    useEffect(() => {
      if (internalRef.current) onLoad?.()
    }, [onLoad])

    return (
      <div
        ref={setRefs}
        {...rest}
        style={{
          display: 'flex',
          flexDirection: direction,
          flex,
          gap,
          alignItems: align,
          justifyContent: justify,
          ...style,
        }}
      >
        {children}
      </div>
    )
  },
)

FlexDiv.displayName = 'FlexDiv'
